<script setup>
import { computed, inject } from 'vue';

const props = defineProps({
    content: {
        type: Object,
        required: true,
    },
});

const resolvedMediaEntryMap = inject('aiPageBuilderMediaEntryMap', null);

const resolvedEntry = computed(() => {
    const mediaBankEntryId = props.content?.media_bank_entry_id ? String(props.content.media_bank_entry_id) : null;

    if (!resolvedMediaEntryMap || !mediaBankEntryId) {
        return null;
    }

    return resolvedMediaEntryMap[mediaBankEntryId] || null;
});

const resolvedPosterEntry = computed(() => {
    const mediaBankEntryId = props.content?.thumbnail_media_bank_entry_id ? String(props.content.thumbnail_media_bank_entry_id) : null;

    if (!resolvedMediaEntryMap || !mediaBankEntryId) {
        return null;
    }

    return resolvedMediaEntryMap[mediaBankEntryId] || null;
});
</script>

<template>
    <div
        v-if="resolvedEntry"
        class="mx-auto overflow-hidden"
    >
        <media-bank-entries-display
            :data="resolvedEntry"
            :autoplay="Boolean(content?.autoplay)"
            :hide-controls="Boolean(content?.hideControls)"
            :loop="Boolean(content?.loop)"
            :video-poster-data="resolvedPosterEntry"
        ></media-bank-entries-display>
    </div>
    <div
        v-else
        class="rounded-xl border border-dashed border-gray-300 p-6 text-center text-sm text-gray-500"
    >
        Video not available
    </div>
</template>
